import { AxiosRequestConfig } from "axios";
import GessanAuthService from "@/services/gessan/auth.service";

export const gessanHandleRequest = (config: AxiosRequestConfig) => {
  const token = GessanAuthService.token;
  const authHeader = token ? `Bearer ${token}` : "";
  config.headers = {
    ...config.headers,
    Authorization: authHeader,
    Accept: "application/json",
    "Content-Type": "application/json"
  };

  return config;
};

export const gessanHandleErrorRequest = (error: any) =>
  Promise.reject(error);
